module.exports = __webpack_public_path__ + "static/media/addition-budget-icon.bc72f615.svg";